import { createBrowserHistory } from "history";
export default createBrowserHistory({
  getUserConfirmation(message: any, callback: any) {
    // Show some custom dialog to the user and call
    // callback(true) to continue the transiton, or
    // callback(false) to abort it.
  },
});
